/**
 * Menu View
 */

define(function(require, exports, module) {
    'use strict';
    var $ = require('j');
    var core = require('core');
    var user = require('user');
    var _ = require('underscore');
    var config = require('config');
    var urlUtil = require('util/url.util');
    var device = require('util/device.util');
    var BaseView = require('common/base.view');
    var scrollManager = require('managers/scroll.manager');
    var MenuModel = require('modules/menu/menu.model.instance');
    var communicationApi = require('modules/api/communication.api');
    var quickDepositService = require('modules/cashier/quick-deposit/quick-deposit.service.instance');

    require('widgets/accordion.widget');

    module.exports = BaseView.extend({

        model: MenuModel,

        opened: false,

        content: null,

        className: 'fn-slide-menu',

        events: {
            'tap a': 'handleLinkNavigate',
            'tap .fn-close-menu': 'handleCloseTap',
            'tap .fn-open-chat': 'handleOpenChat',
            'tap .fn-open-inbox': 'handleOpenInbox',
            'mouseover .fn-menu-nav-item': 'handleMenuItemMouseover',
            'mouseover .fn-menu-hover': 'handleMouseoverMenu',
            'mouseout .fn-menu-nav-item': 'handleMouseoutMenu',
            'mouseout .fn-menu-hover': 'handleMouseoutMenu'
        },

        initialize: function() {
            this.urlToIsMenuHovered = [].reduce.call(config.get('menuItems'), function(result, current) {
                result[current.url] = current.isHoverMenu;
                return result;
            }, {});
        },

        subscribe: function() {
            this.listenTo(core, {
                'page:clear page:refresh navigate': this.close,
                'page:rendered navigate': this.handleNavigate,
                'menu:action:open': this.open,
                'menu:action:close': this.close,
                'popup:rendered navigate': _.compose(this.close, this.hideSubMenu),
                'auth:login auth:logout page:refresh': this.render,
                'inbox:open': this.close,
                'chat:open': this.close
            });

            this.listenTo(quickDepositService, {
                'change:isQuickDepositAvailable': this.render
            });

            if (!this.isDesktopMenu()) {
                $.event.add(window, 'orientationchange', function() {
                    if (this.opened) {
                        if (device.browserName === 'androidNative' && device.alias === 'Lenovo_A850') {
                            this.redraw(this.el, 1200);
                            this.redraw($('.fn-overlay'), 500);
                        } else if (device.os === 'android') { // trigger redraw event for setting right height
                            this.redraw(this.el, 500);
                        }

                        // redraw list item for correct scrolling in ios
                        if (device.name === 'ipad' && device.osVersion === '8.1.1') {
                            return;
                        }

                        if (this.$('.fn-menu-list').length) {
                            this.redraw(this.$('.fn-menu-list'));
                        }
                    }
                }.bind(this));
            }
        },

        setBackgroundPage: function(backgroundPage) {
            this.backgroundPage = backgroundPage || urlUtil.pathname;
        },

        setSlideMenuWcId: function(slideMenuWcId) {
            this.slideMenuWcId = slideMenuWcId;
        },

        handleOpenChat: function(event) {
            event.preventDefault();

            var chatAPI = communicationApi('chat');
            var isEnabled = config.get('chatWidget') && config.get('chatWidget').enabled;

            if (!isEnabled) {
                return;
            }

            const windowStatus = chatAPI('getWindowStatus');

            if (windowStatus && (windowStatus.activeScreen === 'CHAT_UI__ICON' || windowStatus.hidden)) {
                chatAPI('maximize');
                communicationApi('inbox') && communicationApi('inbox')('minimize');
            }
        },

        handleOpenInbox: function(event) {
            event.preventDefault();

            var inboxAPI = communicationApi('inbox');
            var isEnabled = config.get('inboxWidget') && config.get('inboxWidget').enabled;

            if (!inboxAPI || !isEnabled) {
                return;
            }

            var status = inboxAPI('getWindowStatus') || {};

            if (status.close) {
                return inboxAPI('showInboxTab');
            }

            if (status.hide) {
                communicationApi('chat') && communicationApi('chat')('minimize');

                return inboxAPI('maximize');
            }
        },

        handleLinkNavigate: function(e) {
            e.preventDefault();

            var path = e.currentTarget.getAttribute('href') || e.currentTarget.dataset.url;
            var target = e.currentTarget.getAttribute('target');

            return core.navigate(path, { target });
        },

        handleCloseTap: function() {
            this.close();
        },

        handleMouseoutMenu: function() {
            if (Playtech.API.page?.isPageInPopupUrl()) {
                return;
            }

            this.hideSubMenu();
        },

        handleMouseoverMenu: function() {
            this.isMenuShown = true;
        },

        handleMenuItemMouseover: function(e) {
            if (e.currentTarget.dataset.type) {
                this.showSubMenu(e.currentTarget);
            }
        },

        render: function() {
            _.invoke(this.childViews, 'close');

            this.childViews = [];

            this.menuItems = this.model.getFilteredByRoleItems();
            this.menuItems = this.getFilteredByUrlAvailability();

            if (this.isDesktopMenu()) {
                this._renderNavMenu();
            } else {
                this._renderSideMenu();
            }

            if (!this.slideMenuWcId) {
                this.attachWidget(this.$el.accordion({
                    isCollapseSiblings: false,
                    headerExpandedClass: 'fn-accordion-header_expanded slide-menu__list__header_expanded',
                    bodyExpandedClass: 'fn-accordion-body_expanded slide-menu__list__body_expanded'
                }));
            }

            this.activateMenu(this.backgroundPage);

            return this;
        },

        _renderNavMenu: function() {
            this.$el.html(this.tmpl('nav.menu', {
                menuItems: this.menuItems,
                urlToIsMenuHovered: this.urlToIsMenuHovered
            }).replace());
        },

        _renderSideMenu: function() {
            if (this.slideMenuWcId) {
                this.$el.find('.fn-common-slide-menu').remove();

                return;
            }

            this.$el.html(this.tmpl('side.menu', {
                menuItems: this.menuItems,
                isUserLogged: user.isLoggedIn()
            }).replace());

            this.wrap = this.$('.fn-menu-wrap')[0];
            this.list = this.$('.fn-menu-list')[0];
        },

        /**
         * Show menu on page
         */
        open: function() {
            if (this.wrap) {
                this.wrap.scrollTop = 0;
            }

            // prevent body scrolling while menu is open
            scrollManager.disableScrolling(this);

            // hack: ios > 9 fix menu appearing shifted below bottom if opened from lowest scroll position
            if (device.os === 'ios' && parseInt(device.osVersion) >= 9) {
                this.redraw(this.el);
            }
            // hack: adding setTimeout fixes animation on open when `this.redraw()` is called
            window.setTimeout(function() {
                this.$el.addClass('open');
                this.renderOverlay();
                $('.fn-page').addClass('page_state_menu-open');
                this.opened = true;
            }.bind(this), 0);
        },

        isDesktopMenu: function() {
            return device.formFactor === 'desktop';
        },

        /**
         * Hide menu from page
         */
        close: function(callback) {
            if (!this.opened || Playtech.API.page?.isPageInPopupUrl()) {
                return;
            }

            scrollManager.enableScrolling(this);
            $(window).off('.menu');

            this.$el.addClass('close');

            this.transitionEnd(this.$('.fn-slide-menu-wrapper'), function() {
                this.$el.removeClass('open close');
                if (_.isFunction(callback)) {
                    callback();
                }
            }, this);

            this.removeOverlay();

            $('.fn-page').removeClass('page_state_menu-open');

            this.opened = false;
        },

        closeView: function() {
            BaseView.prototype.close.apply(this, arguments);
        },

        activateMenu: function(pageUrl) {
            if (this.isDesktopMenu()) {
                this.toggleSecondlevelMenu(pageUrl);
            }

            this.setActiveMenu(pageUrl);
        },

        handleNavigate: function(pageUrl) {
            if (Playtech.API.page?.isPageInPopupUrl()) {
                return;
            }

            this.activateMenu(pageUrl);
            this.setBackgroundPage(pageUrl);
        },

        /**
         * Add active class for menu item
         */
        setActiveMenu: function(pageUrl) {
            this.$('.active').removeClass('active');

            const currentParentItems = this.model.getCurrentParentItems(pageUrl);
            const currentItem = this.model.getCurrentItem(pageUrl);
            const currentParentItem = this.model.getCurrentParentItem(pageUrl);

            [...currentParentItems, currentItem, currentParentItem].forEach(function(item) {
                if (!item) {
                    return;
                }
                var $link = this.$('[data-url="' + item.friendlyURL + '"]');
                !$link.hasClass('fn-accordion') && $link.addClass('active');
            }, this);
        },

        /**
         * Show second level menu
         */
        toggleSecondlevelMenu: function(pageUrl) {
            var parentItem = this.model.getCurrentParentItem(pageUrl);
            if (!parentItem) {
                this.$('.fn-secondlevel-wrapper, .fn-secondlevel').addClass('hidden');

                return;
            }

            var parentUrl = parentItem.friendlyURL;
            var $menu = this.$('[data-parent-url="' + parentUrl + '"]');
            var isVisible = Boolean($menu.length > 0 && $menu[0].children.length > 0);

            this.$('.fn-secondlevel-wrapper').toggleClass('hidden', !isVisible);
            this.$('.fn-secondlevel').addClass('hidden');
            isVisible && $menu.removeClass('hidden');

            core.trigger('menu:secondLevel:toggle');
        },

        hideSubMenu: function() {
            this.isMenuShown = false;

            var timeout = window.setTimeout(function() {
                window.clearTimeout(timeout);

                if (!this.isMenuShown) {
                    this.$('.fn-sub-menu-item, .fn-menu-subnavigation, .fn-submenu').addClass('hidden');
                }
            }.bind(this), 200);
        },

        showSubMenu: function(target) {
            this.isMenuShown = true;

            this.$('.fn-sub-menu-item, .fn-menu-subnavigation, .fn-submenu').addClass('hidden');

            if (target.dataset.type === 'hover') {
                this.$('.fn-menu-subnavigation').removeClass('hidden');
                this.$('.fn-menu-subnavigation .fn-sub-menu-item[data-url="' + target.dataset.url + '"]')
                    .removeClass('hidden');
            } else {
                this.$('.fn-menu-nav-item[data-url="' + target.dataset.url + '"] .fn-submenu').removeClass('hidden');
            }
        },

        /**
         * Get menu items filtered by chat/inbox availability
         * @return {Object} All menu items except chat and inbox if forbidden
         */
        getFilteredByUrlAvailability: function() {
            var hideInboxByUrl = urlUtil.getLocationParameterByName('hideInbox') === '1';
            var hideChatByUrl = urlUtil.getLocationParameterByName('hideChat') === '1';

            return this.menuItems
                .filter(item => {
                    if (item.inboxOpener) {
                        return !hideInboxByUrl;
                    }

                    if (item.chatOpener) {
                        return !hideChatByUrl;
                    }

                    if (item.children) {
                        item.children = item.children
                            .filter(subItem => !(subItem.inboxOpener && hideInboxByUrl) && !(subItem.chatOpener && hideChatByUrl));
                    }

                    return true;
                });
        },
    });
});
